import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { SimDropdown, FaIcon, SimTableCardHelper } from 'SharedComponents'

const SimTableCard = ({
  innerRef,
  color,
  id,
  name,
  startDate,
  seasonName,
  confirmedGolfers,
  dropdownOptions,
  className,
  golfHub,
  openRegistrationData,
  selectedDropdownOption,
  registrationTitle,
  setRegistrationOpen,
  openPopup,
}) => {
  return (
    <Fragment>
      <style className='hidden'>
        {`
          #row_${id} {
            border-left: 4px solid ${color};

          }
        `}
      </style>
      <span
        ref={ innerRef }
        className={ `glg-table-card ${ className || '' }` }
        id={ `row_${id}` }
      >
        <span className='row first_row'>
          <span className='name_field'>{name}</span>
          <span className='action_field'>
            <SimDropdown items={ dropdownOptions } direction="left" />
          </span>
        </span>
        <span className='row second_row'>
          <span className='second_row_details'>
            <span className='date_field'>
              { startDate && <FaIcon icon='calendar-o' /> }
              { startDate }
            </span>
            <span className='season_field hidden-xs'>
              { seasonName && <span className='season_color' style={{ backgroundColor: color }}/> }
              { seasonName }
            </span>
            <span className='golfers_field'>{confirmedGolfers} golfers</span>
            <span className='season_field hidden-sm'>
              { seasonName && <span className='season_color' style={{ backgroundColor: color }}/> }
              { seasonName }
            </span>
          </span>
          <SimTableCardHelper
            golfHub={ golfHub }
            openRegistrationData={ openRegistrationData }
            selectedDropdownOption={ selectedDropdownOption }
            registrationTitle={ registrationTitle }
            setRegistrationOpen={ setRegistrationOpen }
            openPopup={ openPopup }
            id={ id }
          />
        </span>
      </span>
    </Fragment>
  )
}

SimTableCard.propTypes = {
  innerRef: PropTypes.string,
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  seasonName: PropTypes.string.isRequired,
  confirmedGolfers: PropTypes.number.isRequired,
  dropdownOptions: PropTypes.array.isRequired,
  className: PropTypes.string,
  golfHub: PropTypes.string.isRequired,
  openRegistrationData: PropTypes.object.isRequired,
  selectedDropdownOption: PropTypes.object.isRequired,
  registrationTitle: PropTypes.string.isRequired,
  setRegistrationOpen: PropTypes.func.isRequired,
  openPopup: PropTypes.func.isRequired,
}

export default SimTableCard